module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-R-44.ef4aab50.png";